<!-- <div class="w-full border rounded-md px-4 py-2 flex items-center gap-3 text-gray-600 cursor-pointer" (click)="openPicker()">
  <img class="h-10 w-10" src="../../../assets/CalendarDots.svg" alt="">

  <div class="flex-1 flex justify-center whitespace-nowrap">
    <span *ngIf="value.start && value.end; else placeholder">
      {{ value.start | date: 'dd-MM-yy' }} to {{ value.end | date: 'dd-MM-yy' }}
    </span>
    <ng-template #placeholder>
      DD-MM-YY to DD-MM-YY
    </ng-template>
  </div>
  <mat-date-range-input [rangePicker]="picker" class="hidden">
    <input class="hidden" matStartDate [(ngModel)]="value.start" />
    <input class="hidden" matEndDate [(ngModel)]="value.end" />
  </mat-date-range-input>

  <mat-date-range-picker #picker></mat-date-range-picker>
</div> -->


<div [ngClass]="{'pointer-events-none': params.view || disabled}" class="w-full border rounded-md px-4 h-full flex items-center gap-3 text-gray-600 cursor-pointer" (click)="openPicker()">
  <div class="-ml-10 py-3">
    <mat-date-range-input [min]="min" [max]="max" [rangePicker]="picker" class="hidden text-[1px]">
      <input class="hidden truncate" matStartDate [(ngModel)]="value.start" (ngModelChange)="onDateChange()" placeholder="DD-MM-YY" />
      <input class="hidden truncate" matEndDate [(ngModel)]="value.end" (ngModelChange)="onDateChange()" placeholder="DD-MM-YY" />
    </mat-date-range-input>


    <mat-date-range-picker #picker></mat-date-range-picker>
  </div>
  <img *ngIf="value.end == null" class="h-6 w-6" src="../../../assets/CalendarDots.svg" alt="">
  <div *ngIf="value.end != null" class="w-auto px-1 py-1 -my-2 bg-[#3F41D1] rounded-lg flex justify-center items-center">
    <img class="h-6 w-6 " src="../../../assets/CalendarDotsWhite.svg" alt="">
  </div>

  <div class="flex-1 flex justify-start whitespace-nowrap w-min truncate py-3">
    <span class="[word-spacing:0.16rem] w-auto truncate" *ngIf="value.start && value.end; else placeholder">
      {{ value.start | date: 'dd-MM-yyyy' }} To {{ value.end | date: 'dd-MM-yyyy' }}
    </span>
    <ng-template class="[word-spacing:0.16rem]" #placeholder>
      <div class="[word-spacing:0.16rem] w-min truncate">
        DD-MM-YYYY To DD-MM-YYYY
      </div>
    </ng-template>
  </div>

</div>
<div *ngIf="control && control.errors && (control.dirty || control.touched)" class="error-messages ml-3 mt-1">
  <p class="text-red-500" *ngIf="control.errors.required">{{label.includes('_') ? (label | capitalizString) : label}} is required.</p>
  <p class="text-red-500" *ngIf="control.errors.minlength">Minimum length required is {{
    control.errors.minlength.requiredLength }}.
  </p>
  <p class="text-red-500" *ngIf="control.errors.maxlength">Maximum length allowed is {{
    control.errors.maxlength.requiredLength }}.
  </p>
  <p class="text-red-500" *ngIf="control.errors.dateRangeInvalid">Invalid Date Range.</p>
  <p class="text-red-500" *ngIf="control.errors.pastDate || control.errors.fromDateInvalid">Date cannot be in the past.</p>
  <p class="text-red-500" *ngIf="control.errors.futureDate">Date cannot be in the future.</p>
  <p class="text-red-500" *ngIf="control.errors.toDateInvalid">Date cannot be lesser the Start Date</p>
  <p class="text-red-500" *ngIf="control.errors.dateOutOfRange">{{label}} Should be in the Event Range</p>
  <p class="text-red-500" *ngIf="control.errors.startDateInvalid">Start Date cannot be Greater the End Date</p>
  <p class="text-red-500" *ngIf="control.errors.endDateBeforeStartDate">End Date cannot be Lesser the Start Date</p>
</div>
<!-- {{form_group?.get(this.start_control)?.errors | json}} -->
<p class="text-red-500" *ngIf="form_group?.get(this.start_control)?.errors?.error && form_group?.get(this.start_control)?.dirty || form_group?.get(this.start_control)?.touched">{{form_group?.get(this.start_control)?.errors?.error}}</p>